import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getValidSession } from '../pages/helpers/sessionUtils';
import { useSuperAdminAuth } from './SuperAdminAuthContext';
import { usePermission } from '../hooks/usePermission';

export const SuperAdminPrivateRoute = ({ children }) => {
    const token = localStorage.getItem('superAdminToken');
    const { superAdmin, loading } = useSuperAdminAuth();
    const location = useLocation();

    if (!token) {
        return <Navigate to="/superadmin/login" replace />;
    }

    if (!loading && superAdmin && superAdmin.must_change_password && location.pathname !== '/superadmin/first-time-password-reset') {
        return <Navigate to="/superadmin/first-time-password-reset" replace />;
    }

    return children;
};

export const PermissionRoute = ({ moduleKey, actionKey = 'view', children }) => {
    const { hasPermission } = usePermission();
    const token = localStorage.getItem('superAdminToken');
    const { superAdmin, loading } = useSuperAdminAuth();

    if (!token) {
        return <Navigate to="/superadmin/login" replace />;
    }

    if (loading) {
        return <div className="text-center py-5"><div className="spinner-border text-primary" role="status"></div></div>;
    }

    if (superAdmin && superAdmin.must_change_password) {
        return <Navigate to="/superadmin/first-time-password-reset" replace />;
    }

    const permissionString = `${moduleKey}.${actionKey}`;
    if (!hasPermission(permissionString)) {
        return (
            <div className="page-content text-center py-5">
                <div className="container-fluid">
                    <div className="card shadow-sm p-5 mx-auto" style={{ maxWidth: '550px' }}>
                        <i className="ri-shield-keyhole-line text-danger display-1 mb-3"></i>
                        <h3 className="fw-bold text-dark">Access Denied (403 Forbidden)</h3>
                        <p className="text-muted fs-15 mt-2">
                            Your account or role does not have the required <code>{permissionString}</code> permission to access this page.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return children;
};

export const VendorPrivateRoute = ({ children }) => {
    const token = localStorage.getItem('authToken');
    const isValidToken = token && token !== 'undefined' && token !== 'null';
    const session = getValidSession();

    if (!isValidToken && !session) {
        return <Navigate to="/login" replace />;
    }
    return children;
};
